import { render, staticRenderFns } from "./DateDecimalForm.vue?vue&type=template&id=b1265c58&scoped=true"
import script from "./DateDecimalForm.vue?vue&type=script&lang=js"
export * from "./DateDecimalForm.vue?vue&type=script&lang=js"
import style0 from "./DateDecimalForm.vue?vue&type=style&index=0&id=b1265c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1265c58",
  null
  
)

export default component.exports